export default __webpack_public_path__ + "static/video-5-043f0367355c23661014d652b7177dc7.png";